import PropTypes from "prop-types";
import { faReceipt, faClockRotateLeft, faCalendarClock, faCreditCard, faComments, faShieldCheck } from "@fortawesome/pro-regular-svg-icons";
import LandingCard from "./LandingCard";

const Landing2nd = ({ locale }) => {
    // define data for the cards
    const cards = [
        { key: "overview", icon: faReceipt, title: locale.cardTitleOne, content: locale.cardContentOne },
        { key: "postpone", icon: faClockRotateLeft, title: locale.cardTitleTwo, content: locale.cardContentTwo },
        { key: "payplan", icon: faCalendarClock, title: locale.cardTitleThree, content: locale.cardContentThree },
        { key: "pay", icon: faCreditCard, title: locale.cardTitleFour, content: locale.cardContentFour },
        { key: "support", icon: faComments, title: locale.cardTitleFive, content: locale.cardContentFive },
        { key: "security", icon: faShieldCheck, title: locale.cardTitleSix, content: locale.cardContentSix }
    ];

    return (
        <div className='landing-element-container' id="landing-page-2nd">
            <div className='landing-element-content'>
                <div className="row">
                    <div className='col-lg-6 col-md-8 col-xs-12'>
                        <h1>{locale.title}</h1>
                        <p>{locale.subtitle}</p>
                    </div>
                </div>
                <div className="row landing-element-card-row g-0">
                    {cards.map((card) => (
                        <LandingCard
                            key={card.key}
                            icon={card.icon}
                            title={card.title}
                            content={card.content}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

Landing2nd.propTypes = {
    locale: PropTypes.object.isRequired
}

export default Landing2nd;
